import React, { useEffect, useRef, useState, useCallback } from "react";
import LoginForm from "../components/Auth/Login";
import { useLocation, useParams } from "react-router";
import anime from "animejs/lib/anime.es.js";
import { ApiHook } from "../hooks/apiHook";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import SecurityNoticeModal from "../components/Auth/SecurityNoticeModal";
import PhishingAlert from "../components/Common/PhishingAlert";
import logo_user from "../assests/images/iCareNet logo_page-0001.jpg";

const ICARE_LOGO = "/images/iCareNet_logo_page-0001-removebg-preview.png";

const RTL_LANGS = ["ar"];

const applyDirection = (langCode) => {
  const dir = RTL_LANGS.includes(langCode) ? "rtl" : "ltr";
  document.documentElement.dir = dir;
  document.documentElement.lang = langCode;
};

const AuthLayout = () => {
  const { t, i18n } = useTranslation();
  const containerRef = useRef(null);
  const location = useLocation();
  const params = useParams();
  const [selectedPage, setSelectedPage] = useState("login");

  const toggleLanguage = useCallback(() => {
    const newLang = i18n.language === "ar" ? "en" : "ar";
    i18n.changeLanguage(newLang);
    localStorage.setItem("userLanguage", JSON.stringify({ code: newLang }));
    applyDirection(newLang);
  }, [i18n]);

  useEffect(() => {
    applyDirection(i18n.language);
    return () => {
      document.documentElement.dir = "ltr";
      document.documentElement.lang = "en";
    };
  }, [i18n.language]);

  // ------------------------------------------------ API -----------------------------------------------
  const company = ApiHook.CallCompanyLogo();
  const companyDetails = useSelector((state) => state.replica?.companyDetails);
  const brandLogo = companyDetails?.logo || ICARE_LOGO;

  // Extract the source query parameter and set it in localStorage
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const source = queryParams.get('source');
    if (source) {
      localStorage.setItem('source', source);
    }
  }, [location.search]);
  
  useEffect(() => {
    const slideInAnimation = anime.timeline({
      autoplay: false,
    });
    slideInAnimation.add({
      targets: containerRef.current,
      translateX: ["-100%", "0%"],
      easing: "easeOutQuart",
      duration: 1200,
    });

    slideInAnimation.play();

  }, [location.pathname]);

  return (
    <div
      ref={containerRef}
      style={{ position: "relative", width: "100%", height: "100%" }}
    >
      <section className="loginSection">
        <button
          type="button"
          onClick={toggleLanguage}
          className="lang-switcher-btn"
        >
          {i18n.language === "ar" ? "EN" : "عربي"}
        </button>
        <div className="container centerDiv">
          <div className="loginBgImg"></div>
          <div className="loginBg">
            <div className="row">
              {selectedPage === "resetPassword" &&
                <div className="forgot_password_header">
                  <h3 onClick={() => setSelectedPage("login")}>
                    <a>
                      <i className={`fa ${i18n.language === "ar" ? "fa-angle-right" : "fa-angle-left"}`}></i>
                    </a>{" "}
                    {t("login")}
                  </h3>
                </div>
              }
              <LoginForm params={params} selectedPage={selectedPage} setSelectedPage={setSelectedPage} />
              <PhishingAlert logo={brandLogo} />
              <SecurityNoticeModal />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AuthLayout;
